import React, { useContext, useState } from 'react';
import { Card } from 'react-bootstrap';
import { LocalizeContext } from 'react-locale-language';
import { toast } from 'react-toastify';
import { makeApiRequests } from '../../../helpers/api';
import { ENDPOINTS } from '../../../helpers/constants';
import RichTextEditor from '../../common/rich-text-editor/RichTextEditor';
import QuestionBuilder from '../../common/QuestionBuilder/QuestionBuilder';

const CompGeneralInfo = ({ comp, onCompUpdate }) => {
  const { translate } = useContext(LocalizeContext);
  const [updatingComp, setUpdatingComp] = useState(false);

  const onUpdateGeneralInfoSubmit = async generalInfo => {
    setUpdatingComp(true);

    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.COMPS_WITH_ID(comp._id),
      method: 'PUT',
      requestBody: {
        ...comp,
        customerSurvey: generalInfo
      }
    });

    setUpdatingComp(false);
    if (error) {
      toast.error(error);
      return;
    }

    if (!comp.customer && response) localStorage.setItem('comps', JSON.stringify(response));

    toast.success('Info updated succesfully!');
    onCompUpdate(response);
  };

  return (
    <Card className="mt-3">
      <Card.Header className="flex justify-between items-center">
        <span>{translate('general_information')}</span>
      </Card.Header>
      <Card.Body className="p-3">
        <QuestionBuilder
          data={comp?.customerSurvey}
          mode="admin"
          disabled={updatingComp}
          onSubmit={onUpdateGeneralInfoSubmit}
        />
      </Card.Body>
    </Card>
  );
};

export default CompGeneralInfo;
